import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgClock(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "clock_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#clock_svg__a)",
      strokeWidth: 3
    }, {
      children: [_jsx("path", {
        d: "M25.394 56.84a23.49 23.49 0 009.87 2.16c13.068 0 23.66-10.638 23.66-23.76 0-13.122-10.592-23.76-23.66-23.76a23.512 23.512 0 00-15.593 5.89 23.817 23.817 0 00-6.236 8.69",
        stroke: "#7373FF",
        strokeLinecap: "round"
      }, void 0), _jsx("rect", {
        x: 29.926,
        y: 5,
        width: 11,
        height: 6.249,
        rx: 1,
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M56.236 14.867l-3.042 3.054M60 17.96l-6.844-6.873M15.023 14.867l3.042 3.054M11.26 17.96l6.843-6.873",
        stroke: "#7373FF",
        strokeLinecap: "round"
      }, void 0), _jsx("circle", {
        cx: 35.539,
        cy: 36.58,
        r: 3.5,
        stroke: "#FF6652"
      }, void 0), _jsx("path", {
        d: "M35.803 31.46v-9.18",
        stroke: "#FF6652",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, void 0), _jsx("path", {
        stroke: "#FF6652",
        strokeLinecap: "round",
        d: "M5.5 33.74h13.593M13.028 42.38h7.37M7.764 50.9H20.21"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgClock;